import { render, staticRenderFns } from "./resultList.vue?vue&type=template&id=2cdc44be&scoped=true&"
import script from "./resultList.vue?vue&type=script&lang=js&"
export * from "./resultList.vue?vue&type=script&lang=js&"
import style0 from "./resultList.vue?vue&type=style&index=0&id=2cdc44be&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.7.2@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cdc44be",
  null
  
)

export default component.exports